import { render } from "./header-nav.vue?vue&type=template&id=c88d95b4&scoped=true"
import script from "./header-nav.vue?vue&type=script&lang=js"
export * from "./header-nav.vue?vue&type=script&lang=js"

import "./header-nav.vue?vue&type=style&index=0&id=c88d95b4&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88d95b4"]])

export default __exports__